/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Prices_To_RecalculateInputs */

const en_prices_to_recalculate = /** @type {(inputs: Prices_To_RecalculateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prices to recalculate`)
};

/**
* | output |
* | --- |
* | "Prices to recalculate" |
*
* @param {Prices_To_RecalculateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const prices_to_recalculate = /** @type {((inputs?: Prices_To_RecalculateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Prices_To_RecalculateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_prices_to_recalculate(inputs)
});